export default "/images/designed-dark.svg?15b35c19ab4560c6b49041b88bba755b";